import { Logos } from "../../../../../Pages/Common/User Management/HelperFunctions";

const selectedIcon = (fileName) => {
  const ext = fileName.split(".").pop();
  switch (ext.toLowerCase()) {
    case "jpg":
    case "png":
    case "jpeg":
    case "gif":
    case "awif":
      return Logos.IMAGE_ICON;
    case "docx":
    case "doc":
      return Logos.WORD_ICON;
    case "xlsx":
    case "xlsm":
    case "xlsb":
    case "xls":
      return Logos.EXCEL_ICON;

    case "ppt":
    case "pptx":
    case "pptm":
    case "potm":
    case "ppsx":
    case "pps":
    case "ppam":
      return Logos.PPT_ICON;

    case "pdf":
      return Logos.PDF_ICON;

    default:
      return Logos.GENERICDOC_ICON;
  }
};
export default selectedIcon;
